import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import CustomSideBar from "../shadcn/components/custom/CustomSideBar";
import { SidebarInset, SidebarProvider } from "../shadcn/components/ui/sidebar";
import LogoSvg from "../icons/LogoSvg";
import HomeIcon from "../icons/HomeIcon";
import LoginSvg from "../icons/LoginSvg";
import AuctionEvents from "../icons/Sidebar/AuctionEvents";
import CalendarIcon from "../icons/CalendarIcon";
import DocIcon from "../icons/DocIcon";
import NotificationIcon from "../icons/NotificationIcon";
import DashboardHeader from "../components/seller/header/DashboardHeader";
import { useDispatch, useSelector } from "react-redux";
import { clearSellerAuth } from "store";

interface SellerDashboardLayoutProps {
  children: React.ReactNode;
}

const SELLER_TABS = [
  {
    tabId: "home",
    text: "Home",
    href: "/",
    icon: <HomeIcon className="w-6 h-6" />,
  },
  {
    tabId: "assets",
    text: "Assets",
    href: "/assets",
    icon: <CalendarIcon className="w-5 h-5" />,
  },
  {
    tabId: "auction-events",
    text: "Auction Events",
    href: "/auction-events",
    icon: <AuctionEvents className="w-6 h-6" />,
  },
  {
    tabId: "binding-offers",
    text: "Binding Offers",
    href: "/binding-offers",
    icon: <NotificationIcon className="w-6 h-6" />,
  },
  {
    tabId: "auction-events",
    text: "Bid Hall",
    href: "/auction-events",
    icon: <AuctionEvents className="w-6 h-6" />,
  },
  {
    tabId: "reports",
    text: "Reports",
    href: "/reports",
    icon: <DocIcon />,
  },
];

export default function SellerDashboardLayout({
  children,
}: SellerDashboardLayoutProps) {
  const router = useRouter();
  const dispatch = useDispatch();
  const { user } = useSelector((state: any) => state.sellerAuth);
  const [currentActiveTab, setCurrentActiveTab] = useState<string>("home");

  useEffect(() => {
    const tab = SELLER_TABS.find(
      (t) =>
        t.href === router.pathname || router.pathname.startsWith(t.href + "/"),
    );
    if (tab) setCurrentActiveTab(tab.tabId);
  }, [router.pathname]);

  const tabClickHandler = (tab: { tabId: string; href: string }) => {
    setCurrentActiveTab(tab.tabId);
    router.push(tab.href);
  };

  const logoutHandler = () => {
    dispatch(clearSellerAuth());
    router.replace("/login");
  };

  return (
    <div className="max-h-screen max-w-full bg-white dark:bg-gray-900">
      <SidebarProvider>
        <CustomSideBar
          tabs={SELLER_TABS}
          currentActiveTabId={currentActiveTab}
          tabOnClickHandler={(t) =>
            tabClickHandler({
              ...t,
              href:
                SELLER_TABS.find((x) => x.tabId === t.tabId)?.href ?? "/seller",
            })
          }
          logo={<LogoSvg />}
          footer={
            <div
              className="flex items-center text-sm font-openSans gap-1 cursor-pointer"
              onClick={logoutHandler}
            >
              <LoginSvg height="40" width="40" bg_color="bg-transparent" />
              <div className="text-brand-textGrey hover:text-brand-textBlack">
                Logout
              </div>
            </div>
          }
        />
        <SidebarInset className="min-w-0 bg-[#F8F8F8]">
          <DashboardHeader
            userNameLabel={user?.profile?.bio?.full_name || "Seller"}
            userEmailLabel={
              user?.attributes?.find((attr: any) => attr.type === "email")
                ?.value || "seller@example.com"
            }
          />
          <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-x-hidden overflow-y-auto bg-white">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
